import { useSession } from 'components/auth/useSession'

import { BaseAuthorization, isCboAndPermissionAuthorization, isPreAuthorizedAuthorization } from './model-authorization'

export const useCheckPermissionAndCboAuthorization = () => {
  const { checkAuthorization } = useSession()

  return (authorization: BaseAuthorization) => {
    if (isPreAuthorizedAuthorization(authorization)) {
      return true
    }

    if (isCboAndPermissionAuthorization(authorization)) {
      return (
        (!authorization.hasAnyCbo || authorization.hasAnyCbo.some(checkAuthorization)) &&
        (!authorization.hasAnyPermission || authorization.hasAnyPermission.some(checkAuthorization))
      )
    }

    return checkAuthorization(authorization.permission)
  }
}
